import { useState, useEffect } from 'react';
import ReactQuill, { Quill } from 'react-quill'
import ImageCompress from 'quill-image-compress';
Quill.register('modules/imageCompress', ImageCompress);
const RichEditor = ({ defaultContentState, setState, noImage }) => {
  const [editorState, setEditorState] = useState(
    defaultContentState
  );
  useEffect(() => {
    setState(editorState);
  }, [editorState]);
  const modules = {
    toolbar: noImage ? 
    [
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline', 'strike'],                                                      // toggled buttons
      ['blockquote', 'code-block'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'align': [] }],
      [{ 'color': [] }, { 'background': [] }],                                                            // dropdown with defaults from theme
    ]
    : [

      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

      ['bold', 'italic', 'underline', 'strike'],                                                      // toggled buttons
      ['blockquote', 'code-block'],

      [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'align': [] }],
      [{ 'color': [] }, { 'background': [] }],                                                            // dropdown with defaults from theme
      ['link', 'image'],
    ],
    imageCompress: {
      quality: 0.7, // default
      maxWidth: 1000, // default
      maxHeight: 1000, // default
      imageType: 'image/jpeg', // default
      debug: true, // default
      suppressErrorLogging: false, // default
      insertIntoEditor: undefined, // default
    }
  }
  return (
    <div>
      <ReactQuill
        placeholder='Görev Detayı'
        value={editorState}
        modules={modules}
        onChange={(e) => {
          setEditorState(e)
        }}
      />
    </div>
  )
}

export default RichEditor